class NorthportInlineSearch extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.northport-inline-search__trigger');
    this.panel = this.querySelector('.northport-inline-search__panel');
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearch = this.querySelector('predictive-search');
    this.desktopQuery = window.matchMedia('(min-width: 1200px)');
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.isPinned = false;
    this.pointerInside = false;

    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onPointerEnter = this.onPointerEnter.bind(this);
    this.onPointerLeave = this.onPointerLeave.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
  }

  connectedCallback() {
    if (!this.trigger || !this.panel || !this.input) return;

    this.panel.hidden = false;
    this.classList.add('is-ready');
    this.trigger.addEventListener('click', this.onTriggerClick);
    this.addEventListener('pointerenter', this.onPointerEnter);
    this.addEventListener('pointerleave', this.onPointerLeave);
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);
    this.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('pointerdown', this.onDocumentPointerDown);
    this.desktopQuery.addEventListener('change', this.onMediaChange);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onTriggerClick);
    this.removeEventListener('pointerenter', this.onPointerEnter);
    this.removeEventListener('pointerleave', this.onPointerLeave);
    this.removeEventListener('focusin', this.onFocusIn);
    this.removeEventListener('focusout', this.onFocusOut);
    this.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('pointerdown', this.onDocumentPointerDown);
    this.desktopQuery.removeEventListener('change', this.onMediaChange);
  }

  onTriggerClick(event) {
    if (!this.desktopQuery.matches) return;

    event.preventDefault();
    this.isPinned = true;
    this.open(true);
  }

  onPointerEnter() {
    if (!this.desktopQuery.matches || !this.hoverQuery.matches) return;

    this.pointerInside = true;
    this.open(false);
  }

  onPointerLeave() {
    this.pointerInside = false;
    window.setTimeout(() => {
      if (!this.isPinned && !this.matches(':focus-within') && !this.pointerInside) this.close(false);
    }, 80);
  }

  onFocusIn() {
    if (this.desktopQuery.matches) this.open(false);
  }

  onFocusOut() {
    window.setTimeout(() => {
      if (!this.isPinned && !this.matches(':focus-within') && !this.pointerInside) this.close(false);
    });
  }

  onKeyDown(event) {
    if (event.key !== 'Escape' || !this.classList.contains('is-open')) return;

    event.preventDefault();
    this.close(true);
  }

  onDocumentPointerDown(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  onMediaChange() {
    if (!this.desktopQuery.matches) this.close(false);
  }

  open(focusInput) {
    this.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    if (focusInput) requestAnimationFrame(() => this.input.focus());
  }

  close(restoreFocus) {
    if (!this.classList.contains('is-open')) return;

    if (restoreFocus) this.trigger.focus();
    this.isPinned = false;
    this.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.predictiveSearch?.close(false);
  }
}

if (!customElements.get('northport-inline-search')) {
  customElements.define('northport-inline-search', NorthportInlineSearch);
}
